import { useCallback, useRef, type ClipboardEvent, type KeyboardEvent, type ReactNode } from 'react'
import { toast } from 'react-toastify'

const COPY_BLOCK_TOAST = 'Không thể copy — đăng nhập và tải xuống để lấy file'
const TOAST_ID = 'skill-copy-blocked'

function notifyBlocked() {
  toast.info(COPY_BLOCK_TOAST, { toastId: TOAST_ID })
}

/**
 * Cho phép chọn/highlight text như bình thường, nhưng chặn copy/cut vào clipboard.
 */
export function SkillCopyGuard({ children, className }: { children: ReactNode; className?: string }) {
  const lastToastAt = useRef(0)

  const softNotify = useCallback(() => {
    const now = Date.now()
    if (now - lastToastAt.current < 1500) return
    lastToastAt.current = now
    notifyBlocked()
  }, [])

  const blockClipboard = useCallback(
    (e: ClipboardEvent) => {
      e.preventDefault()
      softNotify()
    },
    [softNotify]
  )

  const blockShortcut = useCallback(
    (e: KeyboardEvent) => {
      const key = e.key.toLowerCase()
      if ((e.ctrlKey || e.metaKey) && (key === 'c' || key === 'x' || key === 'insert')) {
        e.preventDefault()
        softNotify()
      }
      if (e.shiftKey && key === 'delete') {
        e.preventDefault()
        softNotify()
      }
    },
    [softNotify]
  )

  return (
    <div
      className={className}
      tabIndex={0}
      onCopy={blockClipboard}
      onCut={blockClipboard}
      onContextMenu={(e) => {
        e.preventDefault()
        softNotify()
      }}
      onKeyDown={blockShortcut}
    >
      {children}
    </div>
  )
}
